import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { throwError, of as observableOf, Subject, } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';
import moment from 'moment-timezone';
import { UtilServiceService } from './utilService/util-service.service';

@Injectable({
  providedIn: 'root'
})
export class JoSchedularService {

  public refreshList$: EventEmitter<any>;
 /*******************************  Define endpoint *******************************/
private ENDPOINT_OAUTH_API = "/oauth2-clients";

 constructor(
      private http: HttpClient,
      private util: UtilServiceService,
    ) { 
      this.refreshList$ = new EventEmitter();
      }

/************************************** Get All Maintenance Plans *************************************/
    public getAllBacklogList(search: any, parameters: any,groupBy: string | null,ids: any,activeFilters: any) {
      let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if (activeFilters) {
        Object.keys(activeFilters).forEach(key => {
          if (activeFilters[key] !== null && activeFilters[key].length !== 0 && activeFilters[key] !== undefined && key !== 'createdFromDate' && key !== 'createdToDate') {
            params = params.set(key, activeFilters[key]);
          }
        });
      }
      if (activeFilters?.createdFromDate && activeFilters?.createdToDate) {
      let fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(activeFilters.createdFromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      let toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(activeFilters.createdToDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params.set("createdFromDate", fromDate).set("createdToDate", toDate);
    }
     
       if (groupBy) {
        if(ids && groupBy == 'jobOrderType') {
          params = params.set('joTypeIds', ids);
        }
        if(ids && groupBy == 'serviceZone') {
          params = params.set('serviceZoneIds', ids);
        }
      }
      
      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', parameters.pageSize)
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      return this.http.get(environment.base_url + '/v5/job-orders/backlog?' , { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
  }

  /************************************** Get All Backlog Plans By Group *************************************/
    public getAllBacklogByGroup(search: any, parameters: any,groupBy: string | null,activeFilters: any) {
      let params = new HttpParams();
      if (search !== "" && search != null) {
        params = params.set("search", search);
      }
      if (groupBy) {
        params = params.set('groupBy', groupBy);
      }
       if (activeFilters) {
        Object.keys(activeFilters).forEach(key => {
          if (activeFilters[key] !== null && activeFilters[key].length !== 0 && activeFilters[key] !== undefined && key !== 'createdFromDate' && key !== 'createdToDate') {
            params = params.set(key, activeFilters[key]);
          }
        });
      }
     if (activeFilters?.createdFromDate && activeFilters?.createdToDate) {
      let fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(activeFilters.createdFromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      let toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(activeFilters.createdToDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
      params = params.set("createdFromDate", fromDate).set("createdToDate", toDate);
    }
      
      if (parameters)
        params = params.set('startFrom', parameters.startRow)
          .set('perPage', parameters.pageSize)
          .set('columnName', parameters.sortModel[0].colId)
          .set('sortOrder', parameters.sortModel[0].sort);
      
      return this.http.get(environment.base_url + '/v5/job-orders/backlog/groups?' , { observe: 'response', params: params }).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
  }
 /************************************** Get Brythumn Data *************************************/
  public getBrythumnData(paramsObj: any,activeFilters: any,userSearch: any) {
  let params = new HttpParams();

  // Pagination
  if (paramsObj.startFrom != null)  params = params.set('startFrom', paramsObj.startFrom);
  if (paramsObj.perPage)             params = params.set('perPage', paramsObj.perPage);

  // User / Resource filters
  if (paramsObj.userSearch)          params = params.set('userSearch', paramsObj.userSearch);
  if (userSearch)                    params = params.set('userSearch', userSearch);
  if (paramsObj.userGroupBy)         params = params.set('userGroupBy', paramsObj.userGroupBy);
  if (paramsObj.userSortBy)          params = params.set('userSortBy', paramsObj.userSortBy);
  if (paramsObj.userSortOrder)       params = params.set('userSortOrder', paramsObj.userSortOrder);
  if (paramsObj.userSkillIds)       params = params.set('userSkillIds', paramsObj.userSkillIds);

  //Job Order filters
  if (paramsObj.jobSearch)           params = params.set('jobSearch', paramsObj.jobSearch);
  if (paramsObj?.jobOrderStatuses?.length !== 0 && paramsObj.jobOrderStatuses !== null && paramsObj.jobOrderStatuses !== undefined){   params = params.set('jobOrderStatuses', paramsObj.jobOrderStatuses);}
  if (paramsObj?.joTypeIds?.length !== 0 && paramsObj.joTypeIds !== null && paramsObj.joTypeIds !== undefined){           params = params.set('joTypeIds', paramsObj.joTypeIds);}
  if (paramsObj?.serviceZoneIds?.length !== 0 && paramsObj.serviceZoneIds !== null && paramsObj.serviceZoneIds !== undefined){ 
     params = params.set('serviceZoneIds', paramsObj.serviceZoneIds);
    }
  if (paramsObj.customerIds)         params = params.set('customerIds', paramsObj.customerIds);
  if (paramsObj.assetIds)            params = params.set('assetIds', paramsObj.assetIds);
  if (paramsObj.skillIds)            params = params.set('skillIds', paramsObj.skillIds);
  
   if (paramsObj.createdFromDate && paramsObj.createdToDate) {
      const fromDate = this.util
        .timeFormatter(
          moment('00:00:00', 'h:mm A').format('h:mm A'),
          moment(paramsObj.createdFromDate).format('YYYY-MM-DD')
        )
        .toISOString();
      const toDate = this.util
        .timeFormatter(
          moment('23:59:00', 'h:mm A').format('h:mm A'),
          moment(paramsObj.createdToDate).format('YYYY-MM-DD')
        )
        .toISOString();
      params = params.set('createdFromDate', fromDate).set('createdToDate', toDate);
    }
    
   if (activeFilters) {
        Object.keys(activeFilters).forEach(key => {
          if (activeFilters[key] !== null && activeFilters[key].length !== 0 && activeFilters[key] !== undefined) {
            params = params.set(key, activeFilters[key]);
          }
        });
      }

  
  // Date range
  if (paramsObj.orderFromDate) {
    params = params.set(
      'orderFromDate',
      this.util
        .timeFormatter(
          moment('00:00:00', 'h:mm A').format('h:mm A'),
          moment(paramsObj.orderFromDate).format('YYYY-MM-DD')
        )
        .toISOString()
    );
  }
  if (paramsObj.orderToDate) {
    params = params.set(
      'orderToDate',
      this.util
        .timeFormatter(
          moment('23:59:00', 'h:mm A').format('h:mm A'),
          moment(paramsObj.orderToDate).format('YYYY-MM-DD')
        )
        .toISOString()
    );
  }
 
  return this.http.get(
    environment.base_url + '/v5/job-orders/scheduled',
    { observe: 'response', params }
  ).pipe(
    map((resp: any) => resp),
    catchError(error => throwError(error))
  );
}
  
  /************************************** Get Calendar Data *************************************/
  public getCalendarData(paramsObj: any) {
    let params = new HttpParams();

    const setIfPresent = (key: string, value: any) => {
      if (value === null || value === undefined || value === '') return;
      if (Array.isArray(value)) {
        if (!value.length) return;
        // Comma-separated: jobOrderStatuses=A,B (not repeated keys)
        params = params.set(key, value.join(','));
        return;
      }
      params = params.set(key, value);
    };

    setIfPresent('startDateTime', paramsObj?.startDateTime);
    setIfPresent('endDateTime', paramsObj?.endDateTime);
    setIfPresent('createdDateStartDateTime', paramsObj?.createdDateStartDateTime);
    setIfPresent('createdDateEndDateTime', paramsObj?.createdDateEndDateTime);
    setIfPresent('dateFilter', paramsObj?.dateFilter);
    setIfPresent('search', paramsObj?.search);

    setIfPresent('assetTypeIds', paramsObj?.assetTypeIds);
    setIfPresent('userGroupIds', paramsObj?.userGroupIds);
    setIfPresent('jobOrderServiceZoneIds', paramsObj?.jobOrderServiceZoneIds);
    setIfPresent('assetServiceZoneIds', paramsObj?.assetServiceZoneIds);
    setIfPresent('jobOrderStatuses', paramsObj?.jobOrderStatuses);
    setIfPresent('jobOrderTypeIds', paramsObj?.jobOrderTypeIds);
    setIfPresent('jobOrderCustomerIds', paramsObj?.jobOrderCustomerIds);
    setIfPresent('assetsIds', paramsObj?.assetsIds);

    return this.http.get(
      environment.base_url + '/v5/job-orders/calendar',
      { observe: 'response', params }
    ).pipe(
      map((resp: any) => resp),
      catchError(error => throwError(error))
    );
  }

  /************************************** Clone Job Order (calendar Copy) *************************************/
  public cloneJobOrder(data: {
    jobOrderId: number | string;
    installationStart: string;
    installationEnd: string;
    assigntoUserId: number | string | null;
  }) {
    let params = new HttpParams()
      .set('jobOrderId', String(data.jobOrderId))
      .set('installationStart', data.installationStart)
      .set('installationEnd', data.installationEnd);

    if (data.assigntoUserId != null && data.assigntoUserId !== '') {
      params = params.set('assigntoUserId', String(data.assigntoUserId));
    } else {
      params = params.set('assigntoUserId', 'null');
    }

    return this.http.put(
      environment.base_url + '/v5/job-orders/clone',
      null,
      { observe: 'response', params }
    ).pipe(
      map((resp: any) => {
        this.refreshList$.emit();
        return resp;
      }),
      catchError(error => throwError(error))
    );
  }

  public getJobOrderDetailsByID(JobOrderID: any) {
      let params = new HttpParams();
      
      return this.http.get(environment.base_url + '/v5/job-orders/scheduler/'+JobOrderID , { observe: 'response'}).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
  }
  public getJobOrderActivity(JobOrderID: any) {
      let params = new HttpParams();
      
      return this.http.get(environment.base_url + '/job-order-audit-event-histories/activities?jobOrderId=' + JobOrderID + '&limit=50' , { observe: 'response'}).pipe(map((resp: any) => {
        return resp;
      }
      ), catchError(error => {
        return throwError(error);
      }),);
  }
  public jobOrderReSchedule(data: any) {
  return this.http.put(environment.base_url + '/v5/job-orders/schedule', data,{observe: "response"}).pipe(map((resp: any) => {
     this.refreshList$.emit(); // Emit event to refresh the list after re-assigning
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),); 
}

public jobOrderReAssign(data: any, dateChanged: boolean) {
  return this.http.put(environment.base_url + '/v5/job-orders/assign', data,{observe: "response"}).pipe(map((resp: any) => {
    if(!dateChanged){
      this.refreshList$.emit(); // Emit event to refresh the list after re-assigning
    }
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),); 
}
public updateJobOrderDateTime(data: any) {
  return this.http.put(environment.base_url + '/v5/job-orders/assign-schedule', data,{observe: "response"}).pipe(map((resp: any) => {
    this.refreshList$.emit(); // Emit event to refresh the list after updating date/time
    return resp;
  }
  ), catchError(error => {
    return throwError(error);
  }),);
}


public moveToBacklog(data: any) {
  const unassignPayload = {
    jobOrderId: data.jobOrderId,
    userId    : null,
    applyToAllTasks: true
  };

  const unschedulePayload = {
    jobOrderId      : data.jobOrderId,
    installationTime: null,
    endDateTime     : null,
    estimatedDuration: 0
  };

  // ✅ Chain: unassign → then unschedule
  return this.http.put(
    environment.base_url + '/v5/job-orders/assign',
    unassignPayload,
    { observe: 'response' }
  ).pipe(
    switchMap(() =>
      // ✅ Second API call after first succeeds
      this.http.put(
        environment.base_url + '/v5/job-orders/schedule',
        unschedulePayload,
        { observe: 'response' }
      )
    ),
    map((resp: any) => {
      this.refreshList$.emit(); // ✅ Refresh after both succeed
      return resp;
    }),
    catchError(error => throwError(error))
  );
}
// ✅ New method to generate and retrieve job sheet PDF
public printJobSheet(data: any) {
  return this.http.post(
    environment.base_url + '/v5/job-orders/scheduler/job-sheet/pdf',
    data,
    {
      observe  : 'response',
      // ✅ Must set responseType to blob — without this Angular
      //    tries to parse the PDF bytes as JSON and the response is corrupted
      responseType: 'blob' as 'json'
    }
  ).pipe(
    map((resp: any) => resp),
    catchError(error => throwError(error))
  );
}
// ✅ New method to send email with job sheet PDF
public sendJobSheetEmail(data: any) {
  return this.http.post(
    environment.base_url + '/v5/job-orders/scheduler/job-sheet/email',
    data,
    { observe: 'response' }
  ).pipe(
    map((resp: any) => resp),
    catchError(error => throwError(error))
  );
}
public getTechnicians() {
    return this.http.get(environment.base_url + '/v5/users/technicians-list').pipe(map((resp: any) => {
      return resp;
    }
    ), catchError(error => {
      return observableOf(error);
    }),);
  }
}
